/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">当店で注文された商品を指定されたお届け先に届けるために、Xiaomiはここに提供された<strong>氏名、電話番号、およびお届け先住所</strong>を収集し、商品を届ける配送パートナーに<strong>それらを共有</strong>します。</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">この個人データの処理の法的根拠は、<strong>あなたが当事者である契約の履行のために必要</strong>なためです。</span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">データ保護の権利（例：アクセス、訂正、消去）を行使する場合は、弊社のプライバシーサポートプラットフォーム（
                        <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/support/
                            </span>
                        </a>
                        ）を通じて行うことができます。
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">個人データの処理に関する詳細な情報は、弊社のプライバシーポリシー（
                        <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://privacy.mi.com/all/languages/
                            </span>
                        </a>
                        ）を参照してください。
                    </span>
                </p>
                <br />
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">ご購入前に「Xiaomi Care 利用規約」（
                        <a href="https://www.mi.com/jp/support/terms/xiaomi-care/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">
                                https://www.mi.com/jp/support/terms/xiaomi-care/
                            </span>
                        </a>
                        ）の内容をご確認のうえ、署名してください。
                    </span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)